import { useContext } from "react";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import {
  useDeleteBillsMutation,
  useDownloadBillsMutation,
} from "../../../../hooks/api/mutations/useProcurement";
import { getRandomIntInclusive } from "../../../../helpers";

export const useBillsExtra = ({ closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  const { mutate: deleteBills, isLoading: isDeletingBills } =
    useDeleteBillsMutation();
  const { mutate: downloadBills, isLoading: isDownlaodingBills } =
    useDownloadBillsMutation();

  const handleDeleteBills = (billsDetails) => {
    deleteBills(
      { id: billsDetails?.id },
      {
        onSuccess: () => {
          triggerToast(
            `Bill with No.: ${billsDetails?.bill_number} deleted successfully`,
            "success",
          );
          closeModal();
        },
      },
    );
  };

  const handleDownloadBills = (billsDetails) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 30));
    downloadBills(
      { id: billsDetails?.id },
      {
        onSuccess: (res) => {
          window.open(res?.data?.data?.url);
          triggerToast(
            `Bill with No.: ${billsDetails?.bill_number} downloaded successfully`,
            "success",
          );
          closeModal();
        },
        onSettled: () => {
          setRequestLoaderProgress(100);
        },
      },
    );
  };

  return {
    isDeletingBills,
    isDownlaodingBills,
    handleDeleteBills,
    handleDownloadBills,
  };
};
